import { Attribute, AttributePropertyValues, IAttribute } from "../System.Runtime/Attribute";
import { NAMESPACE } from "./_Namespace";

export type ClientAwareLookupItemAttributePropertyValues =
    AttributePropertyValues
    & {
        foreignEntityAlias: string;
        typeDescription: string;
    };

export type ClientAwareLookupItemAttributeProperties = {
    [name in keyof ClientAwareLookupItemAttributePropertyValues]?: ClientAwareLookupItemAttributePropertyValues[name];
};

export interface IClientAwareLookupItemAttribute extends IAttribute, ClientAwareLookupItemAttributeProperties
{
}

export class ClientAwareLookupItemAttribute extends Attribute implements IClientAwareLookupItemAttribute
{
    public static override classNamespace = NAMESPACE + "ClientAwareLookupItemAttribute";
    public static override className = "ClientAwareLookupItemAttribute";

    public foreignEntityAlias?: string;
    public typeDescription?: string;

    constructor(propertyValues?: Partial<ClientAwareLookupItemAttributePropertyValues>)
    {
        super(propertyValues);

        this.foreignEntityAlias = propertyValues?.foreignEntityAlias;
        this.typeDescription = propertyValues?.typeDescription;
    }
}